<script>
    import { mapState } from "vuex";
    import { isMobile } from "@/utils";
    import { brandHistory } from "@xd/brand-history";
    import BrandTimelineLabel from "@xd/components/brand/BrandTimelineLabel";

    export default {
        name: "BrandTimeline",
        components: { BrandTimelineLabel },
        data() {
            return {
                isAnimated: false,
                isScrollActive: false,
                timeline: JSON.parse(JSON.stringify(brandHistory.timeline)),
            };
        },
        computed: {
            ...mapState("BrandHistory", ["visitedProductSlug"]),
            timelineProducts() {
                return Object.values(this.timeline)
                    .map((value) => value.products)
                    .flat(1);
            },
        },
        mounted() {
            if (!isMobile(1365)) {
                this.observeNavigation();
            }

            if (this.visitedProductSlug.length > 0) {
                this.isAnimated = true;

                const product = this.timelineProducts.find((product) => {
                    return product.slug === this.visitedProductSlug;
                });

                this.setVisibleProductByYear(product.year);
                this.scrollTo(product.slug); // Удалять slug в store если страница входа не Product
                product.isActive = true;
            } else {
                setTimeout(() => {
                    this.isAnimated = true;
                    setTimeout(() => {
                        this.timeline[2016].isActive = true;
                        this.timeline[2016].products[0].isActive = true;
                        this.timeline[2016].products[0].isVisible = true;
                    }, 2000);
                }, 800);
            }
        },
        methods: {
            scrollTo(slug) {
                if (slug) {
                    this.isScrollActive = true;
                    setTimeout(() => {
                        this.isScrollActive = false;
                    }, 750);
                    const top =
                        document.querySelector(`#${slug}`).getBoundingClientRect().top +
                        window.scrollY;

                    window.scrollTo({
                        top: top - 80,
                        behavior: "smooth",
                    });
                }
            },
            setVisibleProductByYear(year) {
                this.timeline[year].isActive = true;
                this.timeline[year].products.forEach((product) => {
                    product.isVisible = true;
                });
            },
            onYearClick(year, isScroll = true) {
                Object.values(this.timeline).forEach((years) => {
                    years.isActive = false;
                    years.products.forEach((product) => {
                        product.isActive = false;
                        product.isVisible = false;
                    });
                });

                this.timeline[year].products[0].isActive = true;
                this.setVisibleProductByYear(year);

                if (isScroll) {
                    this.scrollTo(this.timeline[year].products[0].slug);
                }
            },
            onProductClick({ year, slug }, isScroll = true) {
                this.timeline[year].products.forEach((product) => (product.isActive = false));
                const product = this.timeline[year].products.find((p) => p.slug === slug);
                product.isActive = true;

                if (isScroll) {
                    this.scrollTo(product.slug);
                }
            },
            observeNavigation() {
                const elements = document.querySelectorAll("[data-slug]");

                const options = {
                    root: null,
                    threshold: 1,
                };

                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting && !this.isScrollActive) {
                            const { slug, year } = entry.target.dataset;
                            this.onYearClick(year, false);
                            this.onProductClick({ year, slug }, false);
                        }
                    });
                }, options);

                elements.forEach((element) => observer.observe(element));
            },
        },
    };
</script>

<template>
    <div class="brand-timeline" :class="{ 'is-animated': isAnimated }">
        <div class="brand-timeline__inner">
            <div class="brand-timeline__labels">
                <brand-timeline-label
                    v-for="label in timeline"
                    :key="label.title"
                    :label="label"
                    @on-year-click="onYearClick"
                    @on-product-click="onProductClick"
                ></brand-timeline-label>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .brand-timeline {
        @include bp($bp-desktop-sm) {
            position: relative;
            width: 100%;
            background-color: #fff;
            &::before {
                content: "";
                position: absolute;
                z-index: 2;
                height: 2px;
                top: 37px;
                left: 0;
                width: 0;
                background-color: #000;
                transition: width 1s cubic-bezier(0.4, 0, 1, 1);
            }
            &::after {
                content: "";
                position: absolute;
                top: 0;
                left: -33%;
                right: 0;
                height: 100%;
                background: linear-gradient(to right, transparent 0%, #fff 25%, #fff 100%);
                transition: left 1s cubic-bezier(0.4, 0, 1, 1) 1s;
            }
            &.is-animated {
                &::before {
                    width: 100%;
                }
                &::after {
                    left: 100%;
                }
            }
        }
        @supports (backdrop-filter: blur()) {
            background-color: rgba(#fff, 0.8);
            backdrop-filter: blur(5px);
        }
    }

    .brand-timeline__inner {
        display: flex;
        justify-content: space-between;
        max-width: 1292px;
        height: 90px;
        margin: 0 auto;
        padding: 12px 16px;
        @include bp($bp-desktop-max) {
            max-width: 1440px;
            padding: 12px 90px;
        }
    }

    .brand-timeline__labels {
        @include bp($bp-desktop-sm) {
            display: flex;
            align-items: flex-start;
            width: 100%;
        }
    }
</style>
